import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@material-ui/core';
import { format } from 'date-fns';
import './HomeMobile.css';
import ErrorPopup from './ErrorPopup';
import umpMaskIcon from '../assets/umpire-mask.png';
import umpCapIcon from '../assets/umpire-cap.png';
import cancelledGameIcon from '../assets/cancelled-game.png';

class MyGamesMobile extends Component {
  state = {
    seasonsLoaded: false,
    coachesTeamsLoaded: false,
    defaultGamesLoaded: false,
    isUpdating: false
  };

  componentDidMount() {
    const { getUmpire } = this.props;

    getUmpire();

    let newMobile;

    let date = Date.now();
    let today = format(date, 'MM/DD/YYYY');

    if(this.props.mobile.length > 0){
      newMobile = { ...this.props.mobile, page: 'my-games' }; 
    } else {
      newMobile = { startDate: today, value: 7, page: 'my-games', showAllGames: false}
    }
    
    this.props.updateMobileState(newMobile);

    this.setState({ seasonsLoaded: false, coachesTeamsLoaded: false, defaultGamesLoaded: false, isUpdating: false });
     }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      const {
        fetchingCoachTeamsStatus,
        fetchingSeasonsStatus,
        fetchingMyGamesStatus,
        memberId,
        getCoachesTeams,
        updateUmpireStatus,
        userSeason
      } = this.props;
      const { coachesTeamsLoaded, defaultGamesLoaded } = this.state;

      let seasonsCheck = this.areSeasonsLoaded();
      //let isCoach = this.isCoach();
      let defaultGamesCheck = defaultGamesLoaded;
      let coachesTeamsCheck = coachesTeamsLoaded;

      if (!seasonsCheck)
        seasonsCheck = nextProps.fetchingSeasonsStatus === 'Loaded' || fetchingSeasonsStatus === 'Loaded';

      if (!coachesTeamsCheck) {
        coachesTeamsCheck = nextProps.fetchingCoachTeamsStatus === 'Loaded' || fetchingCoachTeamsStatus === 'Loaded';
      }

      if (!defaultGamesCheck) {
        defaultGamesCheck = fetchingMyGamesStatus !== 'Loaded' && nextProps.fetchingMyGamesStatus === 'Loaded';
      }

      const isUpdating = nextProps.fetchingMyGamesStatus === 'Loading';

      if (seasonsCheck) {
        if (!coachesTeamsCheck) {
          getCoachesTeams(memberId, userSeason);
        }

        if (!defaultGamesCheck && coachesTeamsLoaded && !isUpdating) {
          this.loadDefaultGames(nextProps.teamsCoaching);
        }
      }

      if (this.areDefaultGamesLoaded() && updateUmpireStatus !== nextProps.updateUmpireStatus) {
        this.updateMyGames();
      }

      this.setState({
        seasonsLoaded: seasonsCheck,
        coachesTeamsLoaded: coachesTeamsCheck,
        defaultGamesLoaded: defaultGamesCheck,
        isUpdating: isUpdating
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { seasonsLoaded, coachesTeamsLoaded, defaultGamesLoaded, isUpdating } = this.state;
    if (seasonsLoaded && coachesTeamsLoaded && (!defaultGamesLoaded && !isUpdating)) {
      this.loadDefaultGames(this.props.teamsCoaching);
    }
  }

  isAdmin = () => {
    return this.props.userType === 'Admin';
  };

  isUmpire = () => {
    return this.props.umpireLevel !== null;
    //return false;
  };

  isCoach = () => {
    return this.props.teamsCoaching.length > 0;
    //return true;
  };

  areDefaultGamesLoaded = () => {
    const { fetchingMyGamesStatus } = this.props;
    return fetchingMyGamesStatus === 'Loaded' || fetchingMyGamesStatus === 'Error';
  };

  areSeasonsLoaded = () => {
    const { fetchingSeasonsStatus } = this.props;
    return fetchingSeasonsStatus === 'Loaded' || fetchingSeasonsStatus === 'Error';
  };

  areTeamsCoachingLoaded = () => {
    const { fetchingCoachTeamsStatus } = this.props;
    return fetchingCoachTeamsStatus === 'Loaded' || fetchingCoachTeamsStatus === 'Error';
  };

  loadDefaultGames = teamsBeingCoached => {
    const { memberId, getMyGames, userSeason } = this.props;

    const isUmpire = this.isUmpire();
    //const isAdmin = this.isAdmin();
    const isCoach = this.isCoach();
    let myTeams = '';
    if (teamsBeingCoached.length > 0) {
      for (let i = 0; i < teamsBeingCoached.length; i++) {
        if (i === teamsBeingCoached.length - 1) myTeams += teamsBeingCoached[i].teamId;
        else myTeams += teamsBeingCoached[i].teamId + ',';
      }
    }
    const nullValue = '';

    let teamIds = isCoach ? myTeams : nullValue;
    let umpireId = isUmpire ? memberId : nullValue;
    let today = format(Date.now(), 'MM/DD/YYYY');

    getMyGames(userSeason, teamIds, umpireId, today);
  };

  updateMyGames = () => {
    const { memberId, getUpdatedMyGames, teamsCoaching } = this.props;

    const isUmpire = this.isUmpire();
    //const isAdmin = this.isAdmin();
    const isCoach = this.isCoach();
    let myTeams = '';
    if (teamsCoaching.length > 0) {
      for (let i = 0; i < teamsCoaching.length; i++) {
        if (i === teamsCoaching.length - 1) myTeams += teamsCoaching[i].teamId;
        else myTeams += teamsCoaching[i].teamId + ',';
      }
    }
    const nullValue = '';

    let seasonId = this.props.userSeason;
    let teamIds = isCoach ? myTeams : nullValue;
    let umpireId = isUmpire ? memberId : nullValue;

    getUpdatedMyGames(seasonId, teamIds, umpireId);
  };

  checkForUmpire(object) {
    const maxUmps = object.umpAvailable !== null ? object.umpAvailable : 2;
    if (maxUmps <= object.umpsUsed) {
      return 'mobile-row-blue';
    } else if (object.umpsUsed > 0) {
      return 'mobile-row-yellow';
    } else {
      return 'mobile-row-red';
    }
  }

  renderRowDate(game) {
    const { memberId } = this.props;

    let objectDate = new Date(format(game.startDate, 'MM/DD/YYYY'));
    let daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    let weekDay = daysOfWeek[objectDate.getUTCDay()];
    let numberDay = objectDate.getUTCDate();

    let isPlateUmpire = false;
    if (memberId === game.umpPlateId)
      isPlateUmpire = true;
    let isBaseUmpire = false;
    if (memberId === game.umpBase1Id || memberId === game.umpBase2Id || memberId === game.umpBase3Id)
      isBaseUmpire = true;
      
    return (
      <Grid container spacing={8} direction= "row" alignItems="center">
        <Grid item xs={7} style={{paddingLeft: 8}}>
          <Typography variant="h4" align="center">
            {numberDay}
          </Typography>
          <Typography variant="body1" align="center">
            {weekDay}
          </Typography>
        </Grid>
        <Grid item xs={5} >
          {game.cancelled && <img src={cancelledGameIcon} height="24" width="auto" alt="Cancelled" />}
          {isPlateUmpire && <img src={umpMaskIcon} height="26" width="auto" alt="Umpire Mask" />}
          {isBaseUmpire && <img src={umpCapIcon} height="20" width="auto" alt="Umpire Cap"  />}
        </Grid>
      </Grid>
    );
  }

  renderGame = (gameId, games) => {
    let id = gameId;
    const game = games[gameId];
    return (
      <Grid container spacing={8} direction="row">
        <Grid item xs={3}>
          {this.renderRowDate(game)}
        </Grid>
        <Grid item xs={9}>
          <div className={this.checkForUmpire(game)} key={`upcomingGames-${id}`}>
            <div className="mobile-game-info-container" id={id}>
              <div className="sub-row">
                <Link to={`/selected-game/${gameId}`}>
                  <h3>{`${format(game.startDate, 'h:mm a')} @ ${game.facilityName}`}</h3>
                  <h4>
                    <span>{`${game.divisionName}`}</span>
                    {`${game.homeTeamName} (H) vs ${game.awayTeamName} (A)`}
                  </h4>
                </Link>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {
      myGamesList,
      games,
    } = this.props;

    return (
      <div className="home-mobile-container">
        <div className="form-container-my-upcoming-games">
          <div className="section-heading">
            <div className="section-title">
              <h2 className="left">MY GAMES</h2>
            </div>
          </div>
          <div className="mobile-games-container">
            {!this.state.isUpdating && this.state.defaultGamesLoaded && this.areDefaultGamesLoaded() ? (
              <div>
                {myGamesList.length > 0 && Object.values(games).length > 0 ? (
                  <div>
                    {myGamesList.map((id, index) => {
                      //return <div key={games[id].id}>{this.checkGameDates(id, games)}</div>;
                      return <div key={games[id].id}>{this.renderGame(id, games)}</div>;
                    })}
                  </div>
                ) : (
                  <div className="mobile-empty-table"> Not assigned to any games. </div>
                )}
              </div>
            ) : (
              <div className="mobile-empty-table"> Loading Games... </div>
            )}
          </div>
        </div>
        {this.props.error !== null ? (
          <div>
            <ErrorPopup error={this.props.error} clearErrors={this.props.clearErrors} />
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default MyGamesMobile;



// WEBPACK FOOTER //
// ./src/components/MyGamesMobile.js